import { Button, Grid } from "@deere/fuel-react";
import { Form, Col, Row} from '@deere/ux.uxframe-react'
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { SCBM_STATES_CAMPAIGN } from "../../../utils/surveyLiterals";



export default function ReviewActions({campaign, showAgreementPopupIfRequired }) {
  const history = useHistory();
  const { t } = useTranslation();
  function disableSubmitButtons(campaign) {
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED;
  }

  return (
    <>
    <Row className="card position-sticky fixed-bottom d-print-none">
    <Row className="card position-sticky fixed-bottom">
    <Col md="24" className="card-body p-3 text-right">
    <Form.Group as={Col} className="align-right"> 
      <Grid container justifyContent={"flex-end"} className="d-print-none">
        <Button variant="secondary" className="float-right mr-2" onClick={() => history.goBack()}>
          {t("btn_review_back_to_edit")}
        </Button>
        <Button variant="primary" className="float-right mr-2" onClick={showAgreementPopupIfRequired} disabled={disableSubmitButtons(campaign)} >
          {t("btn_review_submit")}
        </Button>
      </Grid>
      </Form.Group>
    </Col>
      </Row>
      </Row>
    </>
  );
}
